// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Get all share links on the page
      ui.links = doms(".block.share a");

      // Iterate over the links to bind to each
      for (var index = 0; index < ui.links.length; index++) {
        ui.links[index].onclick = block.share;
      }

    },

    /**
     * Method to handle sharing the current page.
     *
     * @method block.share
     */
    share: function(event) {

      event.preventDefault();

      var url;
      var link = window.encodeURIComponent(
        window.location.href
      );

      switch (this.dataset.network) {
        case "facebook":
          url = [
            "https://www.facebook.com/sharer.php",
            "?u=", link,
          ].join("");
          break;
        case "twitter":
          url = [
            "https://twitter.com/intent/tweet",
            "?url=", link,
          ].join("");
          break;
        case "linkedin":
          url = [
            "https://www.linkedin.com/shareArticle?mini=true",
            "&url=", window.encodeURI(link),
            "&title=", window.encodeURI(document.title),
            // "&summary=", window.encodeURI(summary),
          ].join("");
          break;
      }

      if (!window.open(url, "_blank")) {
        window.location.href = url;
      }

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
